import React from 'react';
import { Link} from 'react-router-dom';
import facebook from '../../img/fb.png';
import twitter from '../../img/tw.png';
import instagram from '../../img/is.png';

class Footer extends React.Component{
    render(){//<img src={facebook} className="footer-social-icon" alt="GPI Facebook" />
        return(
             <div className="no-padding no-margin footer-bag">
                 <div className="row blue-ter-bg main-padding no-margin">
                    <div className="col-md-4 small-margin-top">
                        <h5 className="green-pry-color">Get Involved</h5>
                        <p className="footer-text-1">Governance Meter NG is an initiative of <b> The <a target="_blank"  href='https://citizennetwork.org.ng' className='green-sec-color'>Citizen Network of Nigeria</a></b>. <br/> <a className="green-pry-color" href='/get-involved'><b> Get involved </b></a> with the Governance Performance Index to improve governance in your local community</p>
                        <hr/>
                        <h6 className="green-pry-color">Connect on Social Media</h6>
                        <div style={{display:'flex', justifyContent:'flex-start', alignItems:'center'}}>
                        <span style={{display:'flex', justifyContent:'center', alignItems:'center'}} className="footer-social-bag green-sec-bg">
                            <a target="_blank" href="https://www.facebook.com/GovMeterNG/">
                                <i className="fab fa-facebook footer-social-icon" aria-hidden="true"></i>
                            </a>
                        </span>
                        <span style={{display:'flex', justifyContent:'center', alignItems:'center'}} className="footer-social-bag green-sec-bg">
                            <a target="_blank" href="https://twitter.com/GovMeterNG">
                                <i className="fab fa-twitter footer-social-icon" aria-hidden="true"></i>
                            </a>
                        </span>
                        <span style={{display:'flex', justifyContent:'center', alignItems:'center'}} className="footer-social-bag green-sec-bg">
                            <a target="_blank" href="https://instagram.com/GovMeterNG">
                            <i className="fab fa-instagram footer-social-icon" aria-hidden="true"></i>
                            </a>
                        </span>
                        </div>
                    </div>
                    <div className="col-md-4 small-margin-top">
                        <h5 className="green-pry-color">Quick Links</h5>
                        <div>   
                            <Link className="green-sec-color footer-links" to='/GPI/result-board'>View Index</Link>
                        </div>
                        <div>
                            <Link className="green-sec-color footer-links" to='/about-us/who-we-are'>Who We Are</Link>
                        </div>
                        <div>
                            <Link className="green-sec-color footer-links" to='/get-involved'>Get Involved</Link>
                        </div>
                        <div>
                            <Link className="green-sec-color footer-links" to='/privacy'>Privacy Policy</Link>
                        </div>
                        <div>
                            <Link className="green-sec-color footer-links" to='/terms'>Terms of Use</Link>
                        </div>
                        <hr />
                        <p className="footer-text-1">We share new and insights and updates from the GPI. Subscribe to our  newsletter so you don't miss out</p>
                        <a target="_blank" href="https://mailchi.mp/c9eacb05f11a/gpi-newsletter" className="footer-button">Subscribe</a>
                    </div>
                    <div className='col-md-4 small-margin-top'>
                        <h6 className="green-pry-color">Make  a gift to support our work</h6>
                        <p className="footer-text-1 small-margin-top">Support our mission to inspire positive change through improved Governance Performance across the country using the GPI</p> <br/>
                        <a target="_blank" href="https://dashboard.flutterwave.com/donate/uyp8ubcbqil4" className="footer-button">Donate Now</a>
                    </div>
                 </div>
                 
             </div>
        )
    }
}

export default Footer;